import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { LoyaltyCard } from '../menu-types';

import styles from './LoyaltyButton.module.scss';

const LOYALTY_CARD_LOGO_URL =
  'https://www.ikea.com/global/assets/logos/internal-payment-providers/ikea-family-credit-card.svg';

type LoyaltyButtonProps = Readonly<{
  loyaltyCard: LoyaltyCard;
  onClick: (loyaltyCard: LoyaltyCard) => void;
}>;

export function LoyaltyButton({ loyaltyCard, onClick }: LoyaltyButtonProps) {
  const { t } = useTranslation('profile');

  const onClickInternal = useCallback(() => onClick(loyaltyCard), [loyaltyCard, onClick]);

  return (
    <button
      className={styles.loyaltyButton}
      onClick={onClickInternal}
      aria-label={t('sheet.loyaltyCard.open.button.ariaLabel')}
    >
      <img width={42} height={32} src={LOYALTY_CARD_LOGO_URL} alt="" />
    </button>
  );
}
